module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/007-nicaragua-59bd539a8ef8a4dea603c83d766806bb.svg";